import axios from "axios";

export const getClub = async (id, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/clubs/getClub/${id}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
